import { Method } from "~/enums";
import { useUserStore } from "./userStore";
import Swal from "sweetalert2";
import { AttachmentsDto, CodeDto, WorkRequestDetailDto, WorkRequestInfo } from "~/models/dto-types";
import { Attachment, cid_rtu_info_mappings } from "@prisma/client";
import { useCommonCodeStore } from "./commonCodeStore";
import moment from "moment";
import CommonUtils from "~/utils/common-utils";
import { use } from "echarts";
import { useLocalStorage, useSessionStorage } from "@vueuse/core";

interface gpsInfo{
  latitude: number | undefined,
  longitude: number | undefined,
}
interface WorkAttachInfo{
  [x:string] : attachFileInfo[],
  //@ts-ignore
  "workDetail": string,
}

interface attachFileInfo{
  file: File,
  attachSeq: number | null,
  info: any
}

export const useInstallerStore = defineStore("installerStore", {
	state: () => ({
    // workerGpsInfo: {
    //   latitude: process.env.NODE_ENV !== 'production' ? 36.94626 : undefined,
    //   longitude: process.env.NODE_ENV !== 'production' ? 127.429329 : undefined
    // } as gpsInfo,
    workerGpsInfo: 
    useSessionStorage(
      "workerGpsInfo", {} as {
        latitude: undefined,
        longitude: undefined
      } as gpsInfo
    ),
    workRequestList: [] as WorkRequestInfo[],
    chgOwnerRequestList: useLocalStorage("chgOwnerRequestList", [] as WorkRequestInfo[]),
    selectWorkOwner: useSessionStorage("selectWorkOwner", {} as WorkRequestDetailDto | null),
    selectWorkOrgOwner: useSessionStorage("selectWorkOrgOwner", {} as WorkRequestDetailDto | null),
    selectWorkRequest: useSessionStorage("selectWorkRequest", {} as WorkRequestInfo | null),
    rtuQRCode: useSessionStorage("rtuQRCode", process.env.NODE_ENV !== 'production'? 'T24K441OS20000004' : '' as string),
    uninstallRtuQRCode: '' as string,
    originRtuQrCode: '' as string,
    workAttachInfo: {} as WorkAttachInfo,
    rtuQRReaderType: '' as string,
    cmplWorkInfo: useSessionStorage("cmplWorkInfo", {} as WorkRequestDetailDto | null),
    complementContent: useSessionStorage("complementContent", '' as string),
    userSeq: useSessionStorage("userSeq", 0 as number),
    getCategoryCodeInfo: useLocalStorage("getCategoryCodeInfo", [] as CodeDto[]),
    rmk: useSessionStorage("rmk", null as string | null),
    del_file_List: [] as string[],
    // AbortController 관리
    currentAbortController: null as AbortController | null,
    currentWorkSeq: null as number | null,
	}),
	getters: {
    isGpsNull(){
      if(this.workerGpsInfo.latitude === undefined || this.workerGpsInfo.longitude === undefined){
        return true;
      }

      return false;
    }
	},
	actions: {
    init(){
      const userStore = useUserStore();
      this.userSeq = userStore.loginUserInfo?.userSeq as number;
    },
    disConnRtuReset(){
      this.originRtuQrCode = '';
      this.uninstallRtuQRCode = '';
    },
    clearWorkData(){
      this.workRequestList = [] as WorkRequestInfo[];
      this.chgOwnerRequestList = [] as WorkRequestInfo[];
      this.selectWorkOwner = null;
      this.selectWorkOrgOwner = null;
      this.selectWorkRequest = null;
      this.rtuQRCode = '';
      this.workAttachInfo = {} as WorkAttachInfo;
      this.rtuQRReaderType = '';
      this.complementContent = '';
      this.cancelCurrentRequests();
    },
    // AbortController 관리 함수들
    cancelCurrentRequests(){
      if(this.currentAbortController){
        this.currentAbortController.abort();
        this.currentAbortController = null;
        this.currentWorkSeq = null;
      }
    },
    createNewAbortController(workSeq: number){
      // 이전 요청 취소
      this.cancelCurrentRequests();
      
      // 새로운 AbortController 생성
      this.currentAbortController = new AbortController();
      this.currentWorkSeq = workSeq;
      
      return this.currentAbortController;
    },
    isCurrentRequest(workSeq: number): boolean {
      return this.currentWorkSeq === workSeq;
    },
    workAttachInfoClear(workType: string){
      // workType = 'new';

      if(!workType) workType = 'new';

      workType = this.kindParser(workType);

      const commonCodeStore = useCommonCodeStore();
      let workTypeUpper = workType.substring(0, 1).toUpperCase() + workType.substring(1, workType.length);
      let mapCodes = commonCodeStore.getMapCodeList(`fileCategory${workTypeUpper}`) as Map<string, CodeDto>;
      let mapValues = mapCodes.values();
      
      this.getCategoryCodeInfo = [];

      for(let i = 0; i < mapCodes.size; i++){
        this.getCategoryCodeInfo.push(mapValues.next().value as CodeDto);
      }

      this.getCategoryCodeInfo = this.getCategoryCodeInfo.sort((a, b) => {
        if((a.sortOrder as number) > (b.sortOrder as number)) return 1;
        if((a.sortOrder as number) < (b.sortOrder as number)) return -1;
        return 0;
      })


      this.workAttachInfo = {} as WorkAttachInfo;

      for(let i = 0; i < this.getCategoryCodeInfo.length; i++){
        this.workAttachInfo[this.getCategoryCodeInfo[i].code] = [] as attachFileInfo[];
      }
    
      this.workAttachInfo.workDetail = '';
      this.complementContent = '';
      this.rtuQRCode = '';
      this.del_file_List = [];
    },

    /**
     * 작업 리스트 조회
     * @param pageNo       검색 페이지 번호
     * @param pageSize     검색 페이지 노출 사이즈
     * @param gpsLatitude  gps상의 위도
     * @param gpsLongitude gps상의 경도
     * @param searchKind   검색 종류(20: 설치자명)
     * @param searchText   검색 단어
     */
    async getWorkRequest(
      kind: string,
      pageNo?: number, 
      pageSize?: number,
      gpsLatitude?: number,
      gpsLongitude?: number,
      searchText?: string,
      requestType?: string,
      cityCode?: string,
      sigunguCode?: string,
      dongCode?: string,
      engSource?: string,
      isWorkRequests?: string,
      searchKind?: string,
      workStatus?: string,
      installYear?: string,
      startDate?: string,
      endDate?: string,
    ){

      if(searchText?.trim() === ''){
        searchText = undefined;
      }

      const userStore = useUserStore();
      // if(!userSeq) userSeq = userStore.loginUserInfo?.userSeq as number;
      const userSeq = requestType === 'chgOwner' ? this.selectWorkOwner?.userSeq as number : userStore.loginUserInfo?.userSeq;
      
      if(!searchKind) searchText = undefined;
      else if(!searchText) searchKind = undefined;


      try{
        const res = await useCustomFetch(`/api/v1/work/works/${kind}/list`, {method: Method.GET, query: {
          userSeq     : userSeq,
          pageNo      : pageNo,
          pageSize    : pageSize,
          gpsLatitude : gpsLatitude,
          gpsLongitude: gpsLongitude,
          searchKind  : searchKind,
          searchText  : searchText,
          cityCode    : cityCode,
          sigunguCode : sigunguCode,
          dongCode    : dongCode,
          engSource   : engSource,
          isWorkRequests : isWorkRequests,
          workStatus  : workStatus,
          installYear : installYear,
          startDate : startDate,
          endDate : endDate,
        }});

        if(kind === 'reqManages'){
          if(res.data.value){
            res.data.value.content = res.data.value.content.sort((a: any, b: any) => {
              if(a.cid > b.cid){
                return 1;
              } 

              if(a.cid < b.cid){
                return -1;
              }

              return 0
            })

            return res.data.value;
          } else {
            throw new Error(res.error.value?.data.message);
          }
        }

        if(requestType === 'chgOwner'){
          this.chgOwnerRequestList = res.data.value as WorkRequestInfo[];
        } else {
          this.workRequestList = res.data.value as WorkRequestInfo[];
        }
        // console.log(this.workRequestList);
      } catch(e){
        Swal.fire({
      		html: `<p style="font-size: 15px;">오류가 발생하였습니다.<br>잠시 후 다시 시도해주세요.</p>`,
          confirmButtonColor: "#1949e9",
          confirmButtonText: "확인",
          width: "85%",
        })
      }
    },
    /**
     * 선택된 작업 및 설치자 정보를 store에 저장
     * @param cid 설치자 일련번호
     */
    async setSelectRequests(workSeq: number){
      this.selectWorkRequest = this.workRequestList.find(v => v.workSeq === workSeq) as WorkRequestInfo;
    },

    async returnSetRequestOwnerInfo(workSeq: number){
      return this.workRequestList.find(v => v.workSeq === workSeq) as WorkRequestInfo;
    },
    

    /**
     * 작업자의 gps 정보를 저장
     * @param latitude   위도
     * @param longitude  경도
     */
    setWorkerGps(latitude?: number, longitude?: number){
      if(this.workerGpsInfo === null){
        this.workerGpsInfo = {
          latitude: 0,
          longitude: 0,
        }
      }
      this.workerGpsInfo.latitude = latitude as number; this.workerGpsInfo.longitude = longitude as number;
    },
    setQRCode(code: string){
      if(this.rtuQRReaderType === 'uninstall'){
        this.uninstallRtuQRCode = code;
      } else {
        this.rtuQRCode = code;
      }

    },
    clearQRCode(){
      this.rtuQRCode = '';
    },
    /**
     * RTU 시리얼 번호 유효성 체크
     * @param cid CID 번호
     * @param requestRegDate 작업요청일시 
     * @param serialNumber RTU 시리얼 번호
     * @returns 
     */
    async checkRtuSerial(
      serialNumber: string,
      cid: string
    ){
      try{
        const res = await useCustomFetch('/api/v1/work/validationserial', {method: Method.GET, query: {
          serialNumber: serialNumber,
          cid: cid
        }});

        if(res.data.value === null){
          try{
            return JSON.parse(res.error.value?.data.message)[0].message; 
          }catch(e){
            if(res.error.value?.data.message.includes('ErrorMessage:')){
              return res.error.value.data.message.split('ErrorMessage: ')[1].split(' StackTrace')[0];
            }
            return res.error.value?.data.message;
          }
        }

        return res.data.value;

      } catch(e){
        console.error('작업 목록 조회 실패:', e);

        Swal.fire({
      		html: `<p style="font-size: 15px;">오류가 발생하였습니다.<br>잠시 후 다시 시도해주세요.</p>`,
          confirmButtonColor: "#1949e9",
          confirmButtonText: "확인",
          width: "85%",
        })
      }
    },
    
    async rtuConnect(
      workSeq: number,
      workType: string,
      serialNumber?: string,
    ){
      const gpsInfo = this.workerGpsInfo;

      try{
        const res = await useCustomFetch('/api/v1/work/rtuconnect', {method: Method.POST, query: {
          workSeq: workSeq,
          workType: workType,
          userSeq: this.userSeq,
          serialNumber: serialNumber,
          gpsLatitude: gpsInfo?.latitude,
          gpsLongitude: gpsInfo?.longitude
        }});

        if(res.data.value === null){
          return res.error.value;
        }

        return res.data.value;

      }catch(e){
        Swal.fire({
      		html: `<p style="font-size: 15px;">오류가 발생하였습니다.<br>잠시 후 다시 시도해주세요.</p>`,
          confirmButtonColor: "#1949e9",
          confirmButtonText: "확인",
          width: "85%",
        })
      }

    },
    async workDetail(
      workSeq: number,
      userSeq?: number
    ){
      const userStore = useUserStore();
      if(!userSeq) userSeq = userStore.loginUserInfo?.userSeq as number;

      // 새로운 AbortController 생성
      const abortController = this.createNewAbortController(workSeq);

      try{
        const res = await useCustomFetch('/api/v1/work/works/detail', {method: Method.GET, query: {
          workSeq: workSeq,
          userSeq: userSeq
        }});

        if(res.data.value === null){
          throw new Error(res.error.value?.data.value);
        }

        this.selectWorkOwner = res.data.value as WorkRequestDetailDto;
        this.workAttachInfoClear(this.selectWorkOwner.workType as string);
        
        this.selectWorkOrgOwner = null;

        if(this.selectWorkOwner.org_workSeq !== null && this.selectWorkOwner.isAttached === null){
          // const orgSeq = this.selectWorkOwner.org_workSeq !== null ? this.selectWorkOwner.org_workSeq : this.selectWorkOwner.bf_workSeq


          const bfRes = await this.getWorkBeforeDetail(this.selectWorkOwner.workSeq, this.selectWorkOwner.org_workSeq, userSeq);

          if(bfRes !== 400){
            this.selectWorkOrgOwner = bfRes as WorkRequestDetailDto;
            this.selectWorkOwner.attachments = this.selectWorkOrgOwner?.attachments
          } else {
            const res =  await useCustomFetch('/api/v1/work/works/detail', {method: Method.GET, query: {
              workSeq: this.selectWorkOwner.org_workSeq,
              userSeq: userSeq
            }});
            
            if(res.data.value === null){
              throw new Error(res.error.value?.data.value);
            }
  
            this.selectWorkOrgOwner = res.data.value as WorkRequestDetailDto;
  
            this.selectWorkOwner.attachments = (res.data.value as WorkRequestDetailDto).attachments;
          }


        }

        this.complementContent = this.selectWorkOwner.reqContent as string;


        if(this.selectWorkOwner.attachments !== undefined && this.selectWorkOwner.attachments !== null){
          const attachmentsList = this.selectWorkOwner.attachments as AttachmentsDto[]

          for(let i = 0; i < attachmentsList.length; i++){
            // 요청이 취소되었는지 확인
            if(!this.isCurrentRequest(workSeq)){
              return false;
            }

            // if(attachmentsList[i].fileCategory === 'af_box') continue;
            const blob = await this.getAttachFile(attachmentsList[i].attachSeq, abortController.signal);
            
            // 요청이 취소되었는지 다시 확인
            if(!this.isCurrentRequest(workSeq)){
              return false;
            }

            const newFiles = new File([blob], attachmentsList[i].org_attachName as string, {type: 'image/png'});
            this.workAttachInfo[attachmentsList[i].fileCategory].push({file: newFiles, attachSeq: attachmentsList[i].attachSeq, info: attachmentsList[i]});
          }
        }

        this.workAttachInfo.workDetail = this.selectWorkOwner.workContent as string;
        this.rmk = this.selectWorkOwner.rmk;

        return {
          detail: this.selectWorkOwner,
          workAttachInfo: this.workAttachInfo,
        };

      }catch(e){
        // AbortError인 경우 조용히 처리 (사용자에게 알림 표시하지 않음)
        if(e instanceof Error && e.name === 'AbortError'){
          return false;
        }
        
        Swal.fire({
      		html: `<p style="font-size: 15px;">오류가 발생하였습니다.<br>잠시 후 다시 시도해주세요.</p>`,
          confirmButtonColor: "#1949e9",
          confirmButtonText: "확인",
          width: "85%",
        })
        return false;
      }
    },
    async getAttachFile(attachSeq: Number, signal?: AbortSignal){
      try{
        const res = await useCustomFetch('/api/v1/work/works/attach', {
          method: Method.GET, 
          query: {
            attachSeq: attachSeq
          },
          signal: signal
        });

        if(res.data.value === null){
          try{
            return JSON.parse(res.error.value?.data.message)[0].message; 
          }catch(e){
            if(res.error.value?.data.message.includes('첨부파일을 다운로드하는 중에 에러가 발생하였습니다.')){
              return '첨부파일을 다운로드하는 중에 에러가 발생하였습니다.'
            }

            return res.error.value?.data.message;
          }
        }

        return res.data.value;

      }catch(e){
        // AbortError인 경우 조용히 처리
        if(e instanceof Error && e.name === 'AbortError'){
          throw e;
        }
        
        Swal.fire({
      		html: `<p style="font-size: 15px;">오류가 발생하였습니다.<br>잠시 후 다시 시도해주세요.</p>`,
          confirmButtonColor: "#1949e9",
          confirmButtonText: "확인",
          width: "85%",
        })
      }
    },
    
    async chgWorkStatus(
      kind: 'check' | 'checked' | 'work',
      workSeq: number,
    ){
      const gpsInfo = this.workerGpsInfo;
      const route = useRoute();
      const router = useRouter();

      try{
        const res = await useCustomFetch('/api/v1/work/chgWorkStatus', {method: Method.PUT, query: {
          kind: kind,
          workSeq: workSeq,
          userSeq: this.userSeq,
          gpsLatitude: gpsInfo.latitude,
          gpsLongitude: gpsInfo.longitude,
        }});

        if(res.data.value === null){
          if(res.error.value?.data.message.includes('단계가 아닙니다.')){
            Swal.fire({
              html: `<p style="font-size: 15px;">설치 진행 단계가 일치하지 않습니다. 설치자 선택 페이지에서 설치자를 다시 선택해주세요.</p>`,
              confirmButtonColor: "#1949e9",
              confirmButtonText: "확인",
              width: "85%",
            }).then((result) => {
              if(result.isConfirmed){
                router.replace('../owners/list');
                return;
              }
            })
          } else {
            throw new Error(res.error.value?.data.message);
          }
        } else {
          return res.data.value;
        }

      }catch(e){
        Swal.fire({
      		html: `<p style="font-size: 15px;">오류가 발생하였습니다.<br>잠시 후 다시 시도해주세요.</p>`,
          confirmButtonColor: "#1949e9",
          confirmButtonText: "확인",
          width: "85%",
        })
      }

    },
    /**
     * 상세 화면용 snapshot 데이터만 반환 (store 상태 변경 없음)
     */
    async fetchWorkDetailSnapshot(
      workSeq: number,
      userSeq?: number
    ){
      const userStore = useUserStore();
      const resolvedUserSeq = userSeq ?? (userStore.loginUserInfo?.userSeq as number);

      try{
        const res = await useCustomFetch('/api/v1/work/works/detail', {
          method: Method.GET,
          query: {
            workSeq,
            userSeq: resolvedUserSeq,
          },
        });

        if(!res.data.value){
          throw new Error(res.error.value?.data.value ?? '작업 상세를 불러오지 못했습니다.');
        }

        return res.data.value as WorkRequestDetailDto;
      }catch(error){
        Swal.fire({
          html: `<p style="font-size: 15px;">작업 상세 조회 중 오류가 발생했습니다.<br>잠시 후 다시 시도해주세요.</p>`,
          confirmButtonColor: "#1949e9",
          confirmButtonText: "확인",
          width: "85%",
        });
        throw error;
      }
    },
    async rtuConnStatus(
      workSeq: number
    ){

      try{
        const res = await useCustomFetch('/api/v1/work/rtuconnstatus', {method: Method.GET, query: {
          workSeq: workSeq,
          userSeq: this.userSeq
        }});

        if(res.data.value === null){
          return res.error.value?.data.message
        }

        return res.data.value;
      }catch(e){
        Swal.fire({
      		html: `<p style="font-size: 15px;">오류가 발생하였습니다.<br>잠시 후 다시 시도해주세요.</p>`,
          confirmButtonColor: "#1949e9",
          confirmButtonText: "확인",
          width: "85%",
        })
      }
    },
    async rtuRegInfo(
      workSeq: number,
      userSeq?: number
    ){
      if(!userSeq) userSeq = this.userSeq;

      try{
        const res = await useCustomFetch('/api/v1/work/rtureginfo', {method: Method.GET, query: {
          workSeq: workSeq,
          userSeq: userSeq
        }});
        
        if(res.data.value === null){
          return res.error.value
        }

        return res.data.value;
      }catch(e){
        Swal.fire({
      		html: `<p style="font-size: 15px;">오류가 발생하였습니다.<br>잠시 후 다시 시도해주세요.</p>`,
          confirmButtonColor: "#1949e9",
          confirmButtonText: "확인",
          width: "85%",
        })
      }
    },

    
     kindParser(kind: string){
      let result = kind;

      switch(kind){
        case 'chg_rtu'  : {result = 'new'; break;}
        case 'chg_owner': {result = 'new'; break;}
        case 'crtu_cmpl': {result = 'new'; break;}
        case 'cow_cmpl' : {result = 'new'; break;}
        case 'new_cmpl' : {result = 'new'; break;}
        case 'rtu_cmpl' : {result = ''; break;}
        case 'eq_cmpl' : {result = ''; break;}
        case 'eq_onm' : {result = ''; break;}
        case 'rtu_onm' : {result = ''; break;}
        default: {result = 'new'; break;}
      }

      return result;
    },

    async getFormerRequestDetail(workSeq: number){
      if(!workSeq) return '변경 전 요청내역이 존재하지 않습니다.';

      const userSeq = this.userSeq;

      try{
        const res = await useCustomFetch('/api/v1/work/works/detail', {method: Method.GET, query: {
          workSeq: workSeq,
          userSeq: userSeq
        }});

        if(!res.data.value){
          throw new Error(res.error.value?.data.value)
        }

        return res.data.value;

      }catch(e){
        Swal.fire({
      		html: `<p style="font-size: 15px;">오류가 발생하였습니다.<br>잠시 후 다시 시도해주세요.</p>`,
          confirmButtonColor: "#1949e9",
          confirmButtonText: "확인",
          width: "85%",
        })
      }
      
    },


    async rtuNewInstallTempSave(
      kind: string,
      requestKind: 'work_temp' | 'worked' | 'complement' | 'complete',
      onmkind?: 'rtu' | 'eq',
      workSeq?: number,
      userSeq?: number,
    ){
      let codeCategory = kind;
      
      if(this.selectWorkOrgOwner !== null){
        codeCategory = this.selectWorkOrgOwner.workType as string;
      }

      const commonCodeStore = useCommonCodeStore();

      codeCategory = this.kindParser(codeCategory);
      
      const kindUpperCase = codeCategory.substring(0, 1).toUpperCase() + codeCategory.substring(1, codeCategory.length);

      const cateogryList = commonCodeStore.getMapCodeToArray(`fileCategory${kindUpperCase}`);

      // const cid = this.selectWorkOwner?.cid;
      // const requestRegDate = moment(this.selectWorkOwner?.requestRegDate).format('YYYY-MM-DD HH:mm:ss');
      // console.log(requestRegDate,  moment(this.selectWorkOwner?.requestRegDate).format('YYYY-MM-DD HH:mm:ss'), this.selectWorkOwner?.requestRegDate)

      const installWorkSeq = workSeq ? workSeq : this.selectWorkOwner?.workSeq;
      const installUserSeq = userSeq ? userSeq : this.userSeq;

      const gpsLatitude = this.workerGpsInfo.latitude;
      const gpsLongitude = this.workerGpsInfo.longitude;

      let fileList = [] as File[];

      let imageSameCount = 1;

      let contents = {} as {
        [x:string] : string[] | string | null
      };

      let formData = new FormData();

      if(requestKind !== 'complete' && requestKind !== 'work_temp'){
        if(this.workAttachInfo.workDetail === null || this.workAttachInfo.workDetail.toString().trim() === ''){
          if(this.selectWorkOwner?.workType?.includes('cmpl')){
            return '보완 내역을 작성해주세요.';
          } else {
            return '설치 작업 내역을 작성해주세요.';            
          }
        }

        contents.content = this.workAttachInfo.workDetail as string;
      } else {
        contents.content = this.workAttachInfo.workDetail as string;
      }

      if(this.rmk === null) this.rmk = null;
      else if(this.rmk.trim() === '') this.rmk = null;

      contents.rmk = this.rmk;

      if(requestKind === 'complete'){
        contents.content = null;
      }

        let keys = Object.keys(this.workAttachInfo);

        if(requestKind === 'worked'){
          for(let i = 0; i < keys.length; i++){
            let keyName = keys[i];
            if(keyName === 'workDetail') continue;

            if(this.workAttachInfo[keyName].length <= 0) {
              return `${this.getCategoryCodeInfo.find(v => v.code === keyName)?.codeName}을 업로드해주세요.`
            }
          }
        }

        let newFileCount = 1;


        for(let i = 0; i < keys.length; i++){
          let keyName = keys[i] as keyof typeof this.workAttachInfo;
          if(keyName === 'workDetail') continue;

          for(let j = 0; j < this.workAttachInfo[keyName].length; j++){
          
            let fileFormat = this.workAttachInfo[keyName][j];
            let file = fileFormat.file;         

            if(fileFormat.attachSeq === null){
              if(fileList.findIndex(v => v.name === file.name) === -1){
                fileList.push(file);
              } else {
                let filenameLen = file.name.length;
                let fileNameLastDot = file.name.lastIndexOf('.');
                let splitFileName = file.name.substring(0, fileNameLastDot);
                let fileNameExt = file.name.substring(fileNameLastDot, filenameLen).toLocaleLowerCase();
                let newFileBlob = file.slice(0, file.size, file.type);
                let newFile = new File([newFileBlob], `${splitFileName} - (${newFileCount}).${fileNameExt}`, {type: file.type});
                fileList.push(newFile);
                this.workAttachInfo[keyName][j].file = newFile; 
                this.workAttachInfo[keyName][j].attachSeq = null;
                newFileCount++;
              }
            }
          }
        }


        for(let i = 0; i < cateogryList.length; i++){
          if(this.workAttachInfo[cateogryList[i].key].length <= 0){
            contents[cateogryList[i].key] = null;
          } else {
            contents[cateogryList[i].key] = this.workAttachInfo[cateogryList[i].key].map(v => v.attachSeq !== null ? v.attachSeq.toString() : v.file.name);
          }
        }

        contents['del_file'] = [...this.del_file_List];
        if(contents['del_file'].length === 0) contents['del_file'] = null;
      
        formData.append('contents', JSON.stringify(contents));
        
        fileList.forEach((file) => {
          formData.append('files', file);
        })


      try{
        const res = await useCustomFetch(`/api/v1/work/works/${kind}/report`, {method: Method.POST, query: {
          onmkind: onmkind,
          requestKind: requestKind,
          workSeq: installWorkSeq,
          userSeq: installUserSeq,
          gpsLatitude: gpsLatitude,
          gpsLongitude: gpsLongitude
        }, body: formData});


        if(res.data.value === null){
          return res.error.value;
        }

        return true;
        
      }catch(e){
        Swal.fire({
      		html: `<p style="font-size: 15px;">오류가 발생하였습니다.<br>잠시 후 다시 시도해주세요.</p>`,
          confirmButtonColor: "#1949e9",
          confirmButtonText: "확인",
          width: "85%",
        })
      }
    },

    /**
     * 시리얼 번호 유호 검사
     * @param serialNumber rtu 시리얼번호
     * @returns 
     */
    async checkRtuSerialVersion(serialNumber: string){
      try{
        const res = await useCustomFetch('/api/v1/work/checkserial', {method: Method.GET, query: {
          serialNumber: serialNumber
        }});
  
        
        if(res.data.value === null){
          try{
            return JSON.parse(res.error.value?.data.message)[0].message; 
          }catch(e){
            if(res.error.value?.data.message.includes('유효하지 않은 시리얼번호입니다.')){
              return '유효하지 않은 시리얼번호입니다.'
            }
  
            return res.error.value?.data.message;
          }
        }
  
        return res.data.value;
      } catch(e){
        Swal.fire({
      		html: `<p style="font-size: 15px;">오류가 발생하였습니다.<br>잠시 후 다시 시도해주세요.</p>`,
          confirmButtonColor: "#1949e9",
          confirmButtonText: "확인",
          width: "85%",
        })
      }
    },

    /**
     * 작업요청 내역 타입 변경
     * @param workSeq 
     * @param requestkind 
     * @returns 
     */
    async changeWork(
      workSeq: number,
      requestkind: "chg_rtu" | "chg_owner",
      chg_workSeq?: number,
      userSeq?: number
    ){

      if(requestkind === 'chg_owner' && !chg_workSeq) return '변경할 설치자의 작업요청서 일련번호를 입력해주세요.'

      const commonCodeStore = useCommonCodeStore();

      if(!userSeq) userSeq = this.userSeq;

      let codeCategory = this.kindParser(requestkind);

      const kindUpperCase = codeCategory.substring(0, 1).toUpperCase() + codeCategory.substring(1, codeCategory.length);

      const cateogryList = commonCodeStore.getMapCodeToArray(`fileCategory${kindUpperCase}`);

      let contents = {} as {
        [x:string] : string[] | string | null
      };

      for(let i = 0; i < cateogryList.length; i++){
        if(this.workAttachInfo[cateogryList[i].key].length <= 0){
          contents[cateogryList[i].key] = null;
        } else {
          contents[cateogryList[i].key] = this.workAttachInfo[cateogryList[i].key].map(v => v.attachSeq !== null ? v.attachSeq.toString() : v.file.name);
        }
      }

      contents['del_file'] = [...this.del_file_List];

      if(contents['del_file'].length === 0) contents['del_file'] = null;


      let formData = new FormData();

      formData.append('contents', JSON.stringify(contents));

      try{
        const res = await useCustomFetch('/api/v1/work/changes', {method: Method.POST, query: {
          workSeq: workSeq,
          userSeq: userSeq,
          requestkind: requestkind,
          chg_workSeq: chg_workSeq
        }, body: formData});

        if(res.data.value === null){
          try{
            return JSON.parse(res.error.value?.data.message)[0].message; 
          }catch(e){
            // if(res.error.value?.data.message.includes('유효하지 않은 시리얼번호입니다.')){
            //   return '유효하지 않은 시리얼번호입니다.'
            // }
  
            return res.error.value?.data.message;
          }
        }
  
        return res.data.value;

      } catch(e){
        Swal.fire({
      		html: `<p style="font-size: 15px;">오류가 발생하였습니다.<br>잠시 후 다시 시도해주세요.</p>`,
          confirmButtonColor: "#1949e9",
          confirmButtonText: "확인",
          width: "85%",
        })
      }
    },
    async rtuOwnerUninstall(
      workSeq: number,
      requestkind: 'chg_rtu' | 'chg_owner',
      serialNumber?: string,
      remove_workSeq?: number
    ){
      if(requestkind === 'chg_rtu' && !serialNumber) return '제거하려는 RTU 번호를 입력해주세요.';
      if(requestkind === 'chg_owner' && !remove_workSeq) return '제거하려는 설치자의 작업요청 번호를 입력해주세요';

      const userSeq = this.userSeq;
      const gpsLatitude = this.workerGpsInfo.latitude;
      const gpsLongitude = this.workerGpsInfo.longitude;

      try{
        const res = await useCustomFetch(`/api/v1/work/rtuownerUninstall`, {method: Method.POST, query:{
          workSeq: workSeq,
          userSeq: userSeq,
          requestkind: requestkind,
          serialNumber: serialNumber,
          remove_workSeq: remove_workSeq,
          gpsLatitude: gpsLatitude,
          gpsLongitude: gpsLongitude
        }})

        if(res.data.value === null){
          try{
            return JSON.parse(res.error.value?.data.message)[0].message; 
          }catch(e){
            // if(res.error.value?.data.message.includes('유효하지 않은 시리얼번호입니다.')){
            //   return '유효하지 않은 시리얼번호입니다.'
            // }
  
            return res.error.value?.data.message;
          }
        }
  
        return res.data.value;
      }catch(e){
        Swal.fire({
      		html: `<p style="font-size: 15px;">오류가 발생하였습니다.<br>관리자에게 문의해주세요.</p>`,
          confirmButtonColor: "#1949e9",
          confirmButtonText: "확인",
          width: "85%",
        })
      }    
    },
    async getWorkBeforeDetail(
      workSeq: number,
      org_workSeq: number,
      userSeq?: number,
    ){
      if(!userSeq) userSeq = useUserStore().loginUserInfo?.userSeq;;

      const res = await useCustomFetch(`/api/v1/work/works/bfdetail`, {method: Method.GET, query: {
        workSeq: workSeq,
        org_workSeq: org_workSeq,
        userSeq: userSeq,
      }});

      if(res.data.value){
        return res.data.value
      } else {
        return res.error.value?.data.statusCode
      }

    },
    async makeWorkRequest(
      kind: string,
      workType: string,
      workCompany: number,
      cidList: string[],
      worker?: number,
      cityCode?: string,
      sigunguCode?: string,
      dongCode?: string,
      engSource?: string,
      isWorkRequests?: string,
      searchKind?: string,
      searchText?: string,
    ){
      const userStore = useUserStore();

      const userSeq = userStore.loginUserInfo?.userSeq;

      if(!searchKind) searchText = undefined;
      else if(!searchText) searchKind = undefined;

      let formData = undefined;

      if(cidList.length > 0){
        formData = new FormData();
        let data = {
          cid: cidList
        }

        formData.append('contents', JSON.stringify(data));
      }

      try{
        const res = await useCustomFetch(`/api/v1/work/workRequests`, {method: Method.POST, query:{
          kind              : kind,
          userSeq           : userSeq,
          workType          : workType,
          workCompany       : workCompany,
          worker            : worker,
          cityCode          : cityCode,
          sigunguCode       : sigunguCode,
          dongCode          : dongCode,
          engSource         : engSource,
          isWorkRequests    : isWorkRequests,
          searchKind        : searchKind,
          searchText        : searchText
        }, body: formData});

        if(res.data.value){
          return res.data.value;
        } else {
          throw new Error(res.error.value?.data.message);
        }
      }catch(e){
        Swal.fire({
      		html: `<p style="font-size: 15px;">오류가 발생하였습니다.<br>관리자에게 문의해주세요.</p>`,
          confirmButtonColor: "#1949e9",
          confirmButtonText: "확인",
          width: "85%",
        });
      }
    },
    async getWorkHistoryInfo(workSeq: number, userSeq: string){
      try{
        const res = await useCustomFetch(`/api/v1/work/works/history`, {method: Method.GET, query: {
          workSeq: workSeq,
          userSeq: userSeq
        }});

        if(res.data.value){
          return res.data.value
        } else {
          throw new Error(res.error.value?.data.message);
        }
      }catch(e){
        Swal.fire({
      		html: `<p style="font-size: 15px;">오류가 발생하였습니다.<br>관리자에게 문의해주세요.</p>`,
          confirmButtonColor: "#1949e9",
          confirmButtonText: "확인",
          width: "85%",
        });
      }
    },
    async getWorkSerachBarBaseInfo(
      parameter:{
      kind: string, 
      regionKind: string,
      regionName?: string,
      regionCode?: string,
      }
    ){
      try {
        const res = await useCustomFetch(`/api/v1/work/searchBarBaseInfo`, {method: Method.GET, query:{
          kind: parameter.kind,
          regionKind: parameter.regionKind,
          regionName: parameter.regionName,
          regionCode: parameter.regionCode
        }});

        if(res.data.value){
          return res.data.value
        } else {
          throw new Error(res.error.value?.data.meesage);
        }
      }catch(e){
        Swal.fire({
      		html: `<p style="font-size: 15px;">오류가 발생하였습니다.<br>관리자에게 문의해주세요.</p>`,
          confirmButtonColor: "#1949e9",
          confirmButtonText: "확인",
          width: "85%",
        });
      }
    },
    async getAttachDownloader(
      workSeqList  : string[],
      kind         : 'all' | 'select',
      userSeq      : number,
      cityCode?    : string,
      sigunguCode? : string,
      dongCode?    : string,
      engSource?   : string,
      workStatus?  : string,
      installYear? : string,
      searchKind?  : string,
      searchText?  : string,
    ){

      if(!searchKind) searchText = undefined;
      else if(!searchText) searchKind = undefined;

      let formData;

      if(kind === 'select'){
        formData = new FormData();
        let form = {
          workSeq: workSeqList
        }
        formData.append('contents', JSON.stringify(form));
      }


      try{
        const res = await useCustomFetch<Blob>(`/api/v1/work/attachs`, {
          method: Method.POST, 
          query: {
            kind: kind,
            userSeq: userSeq,
            cityCode: cityCode,
            sigunguCode: sigunguCode,
            dongCode: dongCode,
            engSource: engSource,
            workStatus: workStatus,
            installYear: installYear,
            searchKind: searchKind,
            searchText: searchText
          }, 
          body: formData,
          responseType: 'blob'
        });


        if(res.data.value){
          return res.data.value;
        } else {
          throw new Error(res.error.value?.data.meesage);
        }
      }catch(e){
        Swal.fire({
      		html: `<p style="font-size: 15px;">오류가 발생하였습니다.<br>관리자에게 문의해주세요.</p>`,
          confirmButtonColor: "#1949e9",
          confirmButtonText: "확인",
          width: "85%",
        });
      }
    },
    async getWorkMemo(workSeq: number){
      try{
        const res = await useCustomFetch(`/api/v1/work/works/memo`, {method: Method.GET, query: {workSeq: workSeq}});

        if(res.data.value){
          return res.data.value;
        } else {
          throw new Error(res.error.value?.data.message);
        }
      } catch(e){
        Swal.fire({
          html: `<p style="font-size: 15px;">오류가 발생하였습니다.<br>잠시 후 다시 시도해주세요.</p>`,
          confirmButtonColor: "#1949e9",
          confirmButtonText: "확인",
          width: "85%",
        })
      }
    },
    async saveWorkMemo(workSeq: number, memo: string){
      let data = { memo: memo };

      let formData = new FormData();
      formData.append('contents',JSON.stringify(data));

      try{
        const res = await useCustomFetch(`/api/v1/work/works/memo`, {method: Method.PUT, query: {workSeq: workSeq}, body: formData});

        if(res.data.value){
          return res.data.value;
        } else {
          throw new Error(res.error.value?.data.message);
        }
      }catch(e){
        Swal.fire({
          html: `<p style="font-size: 15px;">오류가 발생하였습니다.<br>잠시 후 다시 시도해주세요.</p>`,
          confirmButtonColor: "#1949e9",
          confirmButtonText: "확인",
          width: "85%",
        })
      }
    },
    async removeWorkMemo(workSeq: number){
      try{
        const res = await useCustomFetch(`/api/v1/work/works/memo`, {method: Method.DELETE, query: {workSeq: workSeq}});
      
        if(res.data.value){
          return res.data.value;
        } else {
          throw new Error(res.error.value?.data.message);
        }
      } catch(e) {
        Swal.fire({
          html: `<p style="font-size: 15px;">오류가 발생하였습니다.<br>잠시 후 다시 시도해주세요.</p>`,
          confirmButtonColor: "#1949e9",
          confirmButtonText: "확인",
          width: "85%",
        })
      }
    },
    async workAttachSave(workSeq: number, userSeq: number, kind: string){
      try{
        let keys = Object.keys(this.workAttachInfo);

        let formData = new FormData();

        let codeCategory = kind;
      
        if(this.selectWorkOrgOwner !== null){
          codeCategory = this.selectWorkOrgOwner.workType as string;
        }
  
        const commonCodeStore = useCommonCodeStore();
  
        codeCategory = this.kindParser(codeCategory);
        
        const kindUpperCase = codeCategory.substring(0, 1).toUpperCase() + codeCategory.substring(1, codeCategory.length);

        let contents = {} as {
          [x:string] : string[] | string | null
        };

        const cateogryList = commonCodeStore.getMapCodeToArray(`fileCategory${kindUpperCase}`);


        let fileList = [] as File[];

        let newFileCount = 1;

        for(let i = 0; i < keys.length; i++){
          let keyName = keys[i] as keyof typeof this.workAttachInfo;
          if(keyName === 'workDetail') continue;

          for(let j = 0; j < this.workAttachInfo[keyName].length; j++){
          
            let fileFormat = this.workAttachInfo[keyName][j];
            let file = fileFormat.file;         

            if(fileFormat.attachSeq === null){
              if(fileList.findIndex(v => v.name === file.name) === -1){
                fileList.push(file);
              } else {
                let filenameLen = file.name.length;
                let fileNameLastDot = file.name.lastIndexOf('.');
                let splitFileName = file.name.substring(0, fileNameLastDot);
                let fileNameExt = file.name.substring(fileNameLastDot, filenameLen).toLocaleLowerCase();
                let newFileBlob = file.slice(0, file.size, file.type);
                let newFile = new File([newFileBlob], `${splitFileName} - (${newFileCount}).${fileNameExt}`, {type: file.type});
                fileList.push(newFile);
                this.workAttachInfo[keyName][j].file = newFile; 
                this.workAttachInfo[keyName][j].attachSeq = null;
                newFileCount++;
              }
            }
          }
        }

        for(let i = 0; i < cateogryList.length; i++){
          if(this.workAttachInfo[cateogryList[i].key].length <= 0){
            contents[cateogryList[i].key] = null;
          } else {
            contents[cateogryList[i].key] = this.workAttachInfo[cateogryList[i].key].map(v => v.attachSeq !== null ? v.attachSeq.toString() : v.file.name);
          }
        }

        contents['del_file'] = [...this.del_file_List];
        if(contents['del_file'].length === 0) contents['del_file'] = null;
      
        formData.append('contents', JSON.stringify(contents));
        
        fileList.forEach((file) => {
          formData.append('files', file);
        })


        const res = await useCustomFetch(`/api/v1/work/works/attachs`, 
          {method: Method.POST, query: {workSeq: workSeq, userSeq: userSeq}, body: formData});

        if(res.data.value){
          return res.data.value;
        } else {
          throw new Error(res.error.value?.data.message);
        }


      } catch(e){
        Swal.fire({
          icon: 'error',
          title: '이미지 변경저장 중 오류가 발생하였습니다.',
          confirmButtonColor: "#1949e9",
          confirmButtonText: "확인",
        })
        return false;
      }
    },
    async getRtuInstallReportSearchBarBaseInfo(
      regionKind: string,
      regionName?: string,
      regionCode?: string,
    ){

      try{
        const res = await useCustomFetch(`/api/v1/report/searchBarBaseInfo`, {method: Method.GET, query:{
          regionKind: regionKind,
          regionName: regionName,
          regionCode: regionCode,
        }});

        if(res.data.value){
          return res.data.value;
        } else {
          throw new Error(res.error.value?.data.message);
        }
      }catch(e){
        Swal.fire({
          html: `<p style="font-size: 15px;">오류가 발생하였습니다.<br>관리자에게 문의해주세요.</p>`,
          confirmButtonColor: "#1949e9",
          confirmButtonText: "확인",
          width: "85%",
        });
      }
    },
    async getRtuInstallReportList(
      limit: number,
      cursor?: string,
      parameter?: {
        cityCode?: string,
        sigunguCode?: string,
        dongCode?: string,
        engSource?: string,
        prjKind?: string,
        prjRegYear?: string,
        searchKind?: string,
        searchText?: string,
      }
    ){
      try{
        const res = await useCustomFetch(`/api/v1/report/construction`, {method: Method.GET, query:{
          limit: limit,
          cursor: cursor,
          cityCode: parameter?.cityCode,
          sigunguCode: parameter?.sigunguCode,
          dongCode: parameter?.dongCode,
          engSource: parameter?.engSource,
          prjKind: parameter?.prjKind,
          prjRegYear: parameter?.prjRegYear,
          searchKind: parameter?.searchKind,
          searchText: parameter?.searchText,
        }});

        if(res.data.value){
          return res.data.value;
        } else {
          throw new Error(res.error.value?.data.message);
        }

      }catch(e){
        Swal.fire({
          html: `<p style="font-size: 15px;">오류가 발생하였습니다.<br>관리자에게 문의해주세요.</p>`,
          confirmButtonColor: "#1949e9",
          confirmButtonText: "확인",
          width: "85%",
        });
      }
    },
    async setDefaultInstallReport(){
      try{
        const res = await useCustomFetch(`/api/v1/report/construction/attach/default`, {method: Method.POST});

        if(res.data.value){
          return res.data.value;
        } else {
          throw new Error(res.error.value?.data.message);
        }

      } catch(e){
        Swal.fire({
          html: `<p style="font-size: 15px;">오류가 발생하였습니다.<br>관리자에게 문의해주세요.</p>`,
          confirmButtonColor: "#1949e9",
          confirmButtonText: "확인",
          width: "85%",
        });
      }
    },
    async setInstallReport(data: any){
      try{
        const res = await useCustomFetch('/api/v1/report/construction/attach', {method: Method.PUT, 
          body: data
        });

        if(res.data.value){
          return res.data.value;
        } else {
          throw new Error(res.error.value?.data.message);
        }

      }catch(e){
        Swal.fire({
          html: `<p style="font-size: 15px;">오류가 발생하였습니다.<br>관리자에게 문의해주세요.</p>`,
          confirmButtonColor: "#1949e9",
          confirmButtonText: "확인",
          width: "85%",
        });
      }
    },
    async getAllReportDownload(
      parameter:{
        cityCode: string,
        sigunguCode: string,
        dongCode: string,
        engSource: string,
        prjRegYear: string,
        prjKind: string,
        searchKind: string,
        searchText: string,
        isAllInOne: 'Y' | 'N'
      }
    ){
      try{
        const res = await useCustomFetch(`/api/v1/report/construction/pdf/search`, {method: Method.POST, body: parameter});

        if(res.data.value){
          return res.data.value;
        } else {
          throw new Error(res.error.value?.data.message);
        }
      }catch(e){
        Swal.fire({
          html: `<p style="font-size: 15px;">오류가 발생하였습니다.<br>관리자에게 문의해주세요.</p>`,
          confirmButtonColor: "#1949e9",
          confirmButtonText: "확인",
          width: "85%",
        });
      }
    },
    async resetRtuInstallInfo(workSeq: number){
      try{
        
        const res = await useCustomFetch(`/api/v1/work/works/reset`, {method: Method.POST, query: {workSeq: workSeq}});

        if(res.data.value){
          return res.data.value;
        } else {
          throw new Error(res.error.value?.data.message);
        }

      }catch(e){
        Swal.fire({
          html: `<p style="font-size: 15px;">오류가 발생하였습니다.<br>관리자에게 문의해주세요.</p>`,
          confirmButtonColor: "#1949e9",
          confirmButtonText: "확인",
          width: "85%",
        });
      }
    }
  }
});
